<script lang="ts">
    import AddGame from "@frontend/Components/AddGame.svelte";
    import EditGameForm from "@frontend/Components/EditGameForm.svelte";
    import Modal from "@frontend/Components/Modal.svelte";
    import { push } from "svelte-spa-router";
    import { service } from "../services";
    import { GetCachedToken, me } from "@frontend/user";
    import { AuthenticatedRequestOfDisableGameDTO, AuthenticatedRequestOfDisableInPageDTO, Game, PlayGroupDTO, AuthenticatedRequestOfAddGamesGroupsRequest } from "../walletapi";
    import { imageLink } from "@frontend/helpers";
    import { playGroupsList } from "@frontend/userlist";
    import { onMount } from "svelte";
     import { translate, currentLanguage } from "../Translator";

    // Obtener los grupos al cargar el componente
    async function loadPlayGroups() {
        const requestPayload = {
            Token: GetCachedToken()
        };
        const result = await service.walletapi.playGroupsList(requestPayload);
        if (result.Success && result.Data) {
            playGroupsList.set(result.Data);
        }
    }

    async function DisableGame(game: Game) {
  
      const requestPayload: AuthenticatedRequestOfDisableGameDTO = {
        Token: GetCachedToken(),
        Data:{
            Id : game.Id,
            Enabled: game.Enabled
        }
      };
  
      const disableplayer = await service.walletapi.disableGame(requestPayload);
  }

  async function DisableInPage(game: Game) {
    const requestPayload: AuthenticatedRequestOfDisableInPageDTO = {
      Token: GetCachedToken(),
      Data: {
        Id: game.Id,
        ShowOnMainPage: !game.ShowOnMainPage
      }
    };

    const result = await service.walletapi.disableInPage(requestPayload);
    if (result.Success) {
      // Update the game's ShowOnMainPage property
      game.ShowOnMainPage = !game.ShowOnMainPage;
      paginatedGames = paginatedGames.map(g =>
        g.Id === game.Id ? { ...g, ShowOnMainPage: game.ShowOnMainPage } : g
      );
    }
  }
  
  

  
    type EditAction =
    {
      action: "edit",
      gameid: number;
    };
  
    function dismiss()
    {
      push("/GamesList");
      loadGames();
    }

    type AddAction =
    {
      action: "add"
    };
  
    type RouteParams =
      EditAction |
      AddAction |
      undefined;
    
    export let params: RouteParams = undefined;
  
    let selectedGame: Game | undefined = undefined;
    let selectedGameRouteId: number | undefined;
    let selectedGameRequest = 0;

    let pageSize = 20;
    let currentPage = 1;
    let totalPages = 1;
    let totalItems = 0;
    let paginatedGames: Game[] = [];
    let loadingGames = false;

    async function loadGames() {
        loadingGames = true;
        try {
            const response = await service.walletapi.gamesListPaged({
                Token: GetCachedToken(),
                Data: {
                    Page: currentPage,
                    PageSize: pageSize,
                    SearchName: undefined,
                    PlayerId: undefined,
                    GameId: undefined
                }
            });

            if (response?.Success && response.Data) {
                paginatedGames = response.Data.Items || [];
                totalPages = response.Data.TotalPages || 1;
                totalItems = response.Data.TotalItems || 0;
                if (currentPage > totalPages && totalPages > 0) {
                    currentPage = totalPages;
                }
            } else {
                paginatedGames = [];
                totalPages = 1;
                totalItems = 0;
            }
        } finally {
            loadingGames = false;
        }
    }

    onMount(() => {
        if (!$me) {
            push("/user/Login");
            return;
        }

        const unregisterGameChanged = service.walletapi.registerOperation(
            "GameChanged",
            "GamesList/GameChanged",
            (game: Game) => {
                paginatedGames = paginatedGames.map(current => current.Id === game.Id ? game : current);
                if (selectedGame?.Id === game.Id) selectedGame = game;
            }
        );
        const unregisterGameAdded = service.walletapi.registerOperation(
            "GameAdded",
            "GamesList/GameAdded",
            () => { void loadGames(); }
        );

        void loadPlayGroups();
        void loadGames();

        return () => {
            unregisterGameChanged();
            unregisterGameAdded();
        };
    });

    function getCurrentGroupId(game: Game): number | null {
        const currentGroup = game.GameGroup?.[0];
        return currentGroup?.PlayGroupsId || null;
    }

    function goToPage(page: number) {
        if (page >= 1 && page <= totalPages && page !== currentPage) {
            currentPage = page;
            loadGames();
        }
    }

    function goToPreviousPage() {
        if (currentPage > 1) {
            goToPage(currentPage - 1);
        }
    }

    function goToNextPage() {
        if (currentPage < totalPages) {
            goToPage(currentPage + 1);
        }
    }

    $: {
        const gameId = params?.action === "edit" ? Number(params.gameid) : undefined;
        if (gameId !== selectedGameRouteId) {
            selectedGameRouteId = gameId;
            const request = ++selectedGameRequest;
            selectedGame = undefined;

            if ($me && gameId && Number.isSafeInteger(gameId) && gameId > 0) {
                const visibleGame = paginatedGames.find(game => game.Id === gameId);
                if (visibleGame) {
                    selectedGame = visibleGame;
                } else {
                    void service.walletapi.gamesListPaged({
                        Token: GetCachedToken(),
                        Data: {
                            Page: 1,
                            PageSize: 1,
                            SearchName: undefined,
                            PlayerId: undefined,
                            GameId: gameId
                        }
                    }).then(response => {
                        if (request !== selectedGameRequest || params?.action !== "edit" || Number(params.gameid) !== gameId) return;
                        selectedGame = response?.Success ? response.Data?.Items?.[0] : undefined;
                    }).catch(() => {
                        if (request === selectedGameRequest) selectedGame = undefined;
                    });
                }
            }
        }
    }
  
    function imageError(game: Game) {
      game.Select = undefined;
    }

    let selectedGroups: { [key: number]: { [key: number]: boolean } } = {};

    function initializeSelectedGroups(game: Game) {
        if (!selectedGroups[game.Id]) {
            selectedGroups[game.Id] = {};
            $playGroupsList.forEach(group => {
                selectedGroups[game.Id][group.Id] = game.GameGroup?.some(g => g.PlayGroupsId === group.Id) ?? false;
            });
        }
    }

    async function saveSelectedGroups(game: Game) {
        const gameGroups = selectedGroups[game.Id];
        if (!gameGroups) return;

        const selectedGroupIds = Object.entries(gameGroups)
            .filter(([_, isSelected]) => isSelected)
            .map(([groupId, _]) => parseInt(groupId));

        if (selectedGroupIds.length > 0) {
            const requestPayload: AuthenticatedRequestOfAddGamesGroupsRequest = {
                Token: GetCachedToken(),
                Data: {
                    GameId: game.Id,
                    PlayGroupsIds: selectedGroupIds
                }
            };

            try {
                const result = await service.walletapi.addGamesGroups(requestPayload);
                if (result.Success) {
                    await loadPlayGroups();
                } else {
                    console.error("Error al guardar los grupos:", result.ErrorMessage);
                }
            } catch (error: any) {
                console.error("Error al guardar los grupos:", error.message);
            }
        }
    }

    function toggleGroup(game: Game, groupId: number) {
        if (!selectedGroups[game.Id]) {
            selectedGroups[game.Id] = {};
        }
        selectedGroups[game.Id][groupId] = !selectedGroups[game.Id][groupId];
        selectedGroups = selectedGroups; // Trigger reactivity
    }

    let showGroupModal = false;
    let currentEditingGame: Game | null = null;
    let tempSelectedGroups: { [key: number]: boolean } = {};
    let modalMessage: { type: 'success' | 'error', text: string } | null = null;

    function openGroupModal(game: Game) {
        currentEditingGame = game;
        modalMessage = null; // Reset message when opening modal
        // Inicializar selección temporal
        tempSelectedGroups = {};
        $playGroupsList.forEach(group => {
            tempSelectedGroups[group.Id] = game.GameGroup?.some(g => g.PlayGroupsId === group.Id) ?? false;
        });
        showGroupModal = true;
    }

    function closeGroupModal() {
        showGroupModal = false;
        currentEditingGame = null;
        tempSelectedGroups = {};
        modalMessage = null;
    }

    async function saveGroups() {
        if (!currentEditingGame) return;

        const selectedGroupIds = Object.entries(tempSelectedGroups)
            .filter(([_, isSelected]) => isSelected)
            .map(([groupId, _]) => parseInt(groupId));

        if (selectedGroupIds.length > 0) {
            const requestPayload: AuthenticatedRequestOfAddGamesGroupsRequest = {
                Token: GetCachedToken(),
                Data: {
                    GameId: currentEditingGame.Id,
                    PlayGroupsIds: selectedGroupIds
                }
            };

            try {
                console.log("Sending request with payload:", requestPayload);
                const result = await service.walletapi.addGamesGroups(requestPayload);
                if (result.Success) {
                    modalMessage = {
                        type: 'success',
                        text: result.Message || 'Groups correctly assigned to the game.'
                    };
                    await loadPlayGroups();
                    setTimeout(closeGroupModal, 2000);
                } else {
                    modalMessage = {
                        type: 'error',
                        text: result.ErrorMessage || 'An error occurred while assigning the groups.'
                    };
                }
            } catch (error: any) {
                console.error("Error details:", error);
                modalMessage = {
                    type: 'error',
                    text: 'An error occurred while assigning the groups: ' + error.message
                };
            }
        } else {
            closeGroupModal();
        }
    }

    let showGroupCurrentColumn = false;

    function toggleGroupCurrentColumn() {
        if ($me?.Role === 'Owner') {
            showGroupCurrentColumn = !showGroupCurrentColumn;
        }
    }

    let showRemoveGroupModal = false;
    let currentRemovingGame: Game | null = null;
    let selectedGroupsToRemove: number[] = [];
    let removeModalMessage: { type: 'success' | 'error', text: string } | null = null;

    function openRemoveGroupModal(game: Game) {
        currentRemovingGame = game;
        removeModalMessage = null;
        selectedGroupsToRemove = [];
        
        console.log("Opening remove modal for game:", game);
        console.log("Initial selected groups (empty):", selectedGroupsToRemove);
        showRemoveGroupModal = true;
    }

    function toggleGroupSelection(groupId: number) {
        console.log("Toggling group:", groupId);
        const index = selectedGroupsToRemove.indexOf(groupId);
        if (index === -1) {
            selectedGroupsToRemove = [...selectedGroupsToRemove, groupId];
        } else {
            selectedGroupsToRemove = selectedGroupsToRemove.filter(id => id !== groupId);
        }
        console.log("Updated selected groups:", selectedGroupsToRemove);
    }

    function isGroupSelected(groupId: number): boolean {
        return selectedGroupsToRemove.includes(groupId);
    }

    async function removeGroups() {
        if (!currentRemovingGame) return;

        console.log("Current selected groups:", selectedGroupsToRemove);
        console.log("Current game:", currentRemovingGame);

        if (selectedGroupsToRemove.length > 0) {
            const requestPayload: AuthenticatedRequestOfAddGamesGroupsRequest = {
                Token: GetCachedToken(),
                Data: {
                    GameId: currentRemovingGame.Id,
                    PlayGroupsIds: selectedGroupsToRemove
                }
            };

            console.log("Sending remove request with payload:", JSON.stringify(requestPayload, null, 2));

            try {
                const result = await service.walletapi.removeGamesGroups(requestPayload);
                console.log("Remove response:", result);

                if (result.Success) {
                    removeModalMessage = {
                        type: 'success',
                        text: result.Message || 'Groups successfully removed from the game.'
                    };
                    await loadPlayGroups();
                    setTimeout(closeRemoveGroupModal, 2000);
                } else {
                    removeModalMessage = {
                        type: 'error',
                        text: result.ErrorMessage || 'An error occurred while removing the groups.'
                    };
                }
            } catch (error: any) {
                console.error("Error details:", error);
                removeModalMessage = {
                    type: 'error',
                    text: 'An error occurred while removing the groups: ' + error.message
                };
            }
        } else {
            closeRemoveGroupModal();
        }
    }

    function closeRemoveGroupModal() {
        showRemoveGroupModal = false;
        currentRemovingGame = null;
        selectedGroupsToRemove = [];
        removeModalMessage = null;
    }

</script>
  
  {#if params?.action == "add"}
      <Modal dismiss={dismiss}>
        <AddGame dismiss={dismiss}></AddGame>
      </Modal>
  {/if}
  
  {#if params?.action == "edit"}
    <Modal dismiss={dismiss} size="large">
      {#if !selectedGame}
        <div class="ui negative message">
          <div class="header">No such Game</div>
        </div>
      {:else}
        <EditGameForm game={selectedGame} dismiss={dismiss}></EditGameForm>
      {/if}
    </Modal>
  {/if}
  
  <h1 class="ui centered dividing header">
    {$translate('List of Games')} ({totalItems})
    {#if loadingGames}
      <i class="spinner loading icon"></i>
    {/if}
  </h1>

  <div class="table-actions">
    <a href="#/GamesList/add" class="ui green button">
        <i class="plus icon"></i>
        {$translate('Games')}
    </a>
    {#if $me?.Role === 'Owner'}
        <button class="ui basic button" on:click={toggleGroupCurrentColumn}>
            <i class="ellipsis horizontal icon"></i>
            {$translate('More')}
        </button>
    {/if}
  </div>
   <!-- <button class="ui positive button"  on:click={redirectToAnotherPage}><i class="user plus icon" style="visibility: visible;"></i>Add Manager</button>  -->
  <div class="page-content-container">
    <div class="table-container">
      <table class="playerlist ui celled unstackable striped selectable very compact unselectable table">
    <thead>
       <tr>
        <th style="width: 50px">#</th>
        <th class="column-game-name">{$translate('Game Name')}</th>
        <th class="column-game-code">{$translate('Game code')}</th>
        {#if showGroupCurrentColumn && $me?.Role === 'Owner'}
            <th class="column-front-page">{$translate('In Front Page')}</th>
        {/if}
        {#if showGroupCurrentColumn && $me?.Role === 'Owner'}
            <th>{$translate('Group Current')}</th>
            <th class="column-assign-groups">{$translate('Assign')}</th>
            <th class="column-remove-groups">{$translate('Remove')}</th>
        {/if}
        <th class="column-image">{$translate('Imagen')}</th>
        {#if $me?.Role === 'Owner'}
            <th class="column-enable">{$translate('Enabled')}</th>
        {/if}
        <th class="column-options">{$translate('Options')}</th>
     </tr>
   </thead>
   <tbody>
    
    {#each paginatedGames as game}
       <tr>
        <td class="numeric">{game.Id}</td>
        <td class="column-game-name">
            <span title={game.GameName ?? ""}>{game.GameName ?? ""}</span>
        </td>
        <td class="column-game-code">{game.GameCode ?? ""}</td>
        {#if showGroupCurrentColumn && $me?.Role === 'Owner'}
            <td class="column-front-page">
                <button class="front-page-status" class:active={game.ShowOnMainPage} on:click={() => DisableInPage(game)}>
                    {#if game.ShowOnMainPage}
                        <i class="check icon"></i>
                    {:else}
                        <i class="close icon"></i>
                    {/if}
                </button>
            </td>
        {/if}
        {#if showGroupCurrentColumn && $me?.Role === 'Owner'}
            <td>
                {#if game.GameGroup && game.GameGroup.length > 0}
                    <div class="groups-list-display">
                        {#each game.GameGroup as gameGroup}
                            {#if gameGroup.PlayGroups}
                                <div class="group-tag">
                                    {gameGroup.PlayGroups.GroupName}
                                </div>
                            {/if}
                        {/each}
                    </div>
                {:else}
                    <i class="text-muted">{$translate('No groups assigned')}</i>
                {/if}
            </td>
            <td class="column-assign-groups">
              <button class="ui primary button" on:click={() => openGroupModal(game)}>
                {$translate('Assign')}
              </button>
            </td>
            <td class="column-remove-groups">
                <button class="ui negative button" on:click={() => openRemoveGroupModal(game)}>
                    {$translate('Remove')}
                </button>
            </td>
        {/if}
        <td class="column-image">
          {#if game.Select}
            <img src={imageLink(game.Select)} alt="" style="max-width: 40px; max-height: 40px; object-fit: contain;" on:error={() => imageError(game)}/>
          {:else}
            <i>No image available</i>
          {/if}
        </td>
        {#if $me?.Role === 'Owner'}
            <td class="column-enable">
              <button class="status-button" class:enabled={game.Enabled} on:click={() => DisableGame(game)}>
                {#if game.Enabled}
                  <i class="check icon"></i>
                {:else}
                  <i class="close icon"></i>
                {/if}
              </button>
            </td>
        {/if}
        <td class="column-options">
          <a class="ui primary icon small button" href="#/GamesList/edit/{game.Id}"><i class="edit icon"></i></a>
        </td>
     </tr>
       {/each}     
   </tbody>
   </table>
   </div>
   <div class="pagination-info">{$translate('Page')} {currentPage} {$translate('of')} {totalPages} - {$translate('Total')}: {totalItems} {$translate('Games')}</div>
    <div class="ui pagination menu">
      {#if currentPage > 1}
        <a class="item" on:click={goToPreviousPage}>{$translate('Previous')}</a>
      {/if}
      {#each Array(totalPages) as _, i}
        <a class="item" class:active={i + 1 === currentPage} on:click={() => goToPage(i + 1)}>{i + 1}</a>
      {/each}
      {#if currentPage < totalPages}
        <a class="item" on:click={goToNextPage}>{$translate('Next')}</a>
      {/if}
    </div>
    </div>
  
  {#if showGroupModal && currentEditingGame}
    <Modal dismiss={closeGroupModal}>
        <div class="modal-content">
            <h3 class="ui header">Select Groups for {currentEditingGame.GameName}</h3>
            {#if modalMessage}
                <div class="ui message" class:positive={modalMessage.type === 'success'} class:negative={modalMessage.type === 'error'}>
                    <div class="header">
                        {modalMessage.type === 'success' ? $translate('Success') : $translate('Error')}
                    </div>
                    <p>{modalMessage.text}</p>
                </div>
            {/if}
            <div class="location-style-container">
                <div class="group-items-list">
                    <div class="no-selection-item" class:selected={Object.values(tempSelectedGroups).every(v => !v)}>
                        <span>{$translate('No groups selected')}</span>
                        {#if Object.values(tempSelectedGroups).every(v => !v)}
                            <div class="check-button">
                                <i class="check icon"></i>
                            </div>
                        {/if}
                    </div>
                    {#each $playGroupsList as group}
                        <div
                            class="group-select-item"
                            class:selected={tempSelectedGroups[group.Id]}
                            on:click={() => tempSelectedGroups[group.Id] = !tempSelectedGroups[group.Id]}
                        >
                            <span>{group.GroupName}</span>
                            {#if tempSelectedGroups[group.Id]}
                                <div class="check-button">
                                    <i class="check icon"></i>
                                </div>
                            {/if}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="modal-actions">
                <button class="ui button cancel-button" on:click={closeGroupModal}>{$translate('Cancel')}</button>
                <button class="ui button save-button" on:click={saveGroups}>{$translate('Save')}</button>
            </div>
        </div>
    </Modal>
  {/if}
  
  {#if showRemoveGroupModal && currentRemovingGame}
    <Modal dismiss={closeRemoveGroupModal}>
        <div class="modal-content">
            <h3 class="ui header">Remove Groups from {currentRemovingGame.GameName}</h3>
            {#if removeModalMessage}
                <div class="ui message" class:positive={removeModalMessage.type === 'success'} class:negative={removeModalMessage.type === 'error'}>
                    <div class="header">
                        {removeModalMessage.type === 'success' ? $translate('Success') : $translate('Error')}
                    </div>
                    <p>{removeModalMessage.text}</p>
                </div>
            {/if}
            <div class="location-style-container">
                <div class="group-items-list">
                    {#each $playGroupsList as group}
                        {#if currentRemovingGame.GameGroup?.some(g => g.PlayGroupsId === group.Id)}
                            <div class="group-item">
                                <span class="group-name">{group.GroupName}</span>
                                <label class="checkbox-container">
                                    <input 
                                        type="checkbox" 
                                        checked={isGroupSelected(group.Id)}
                                        on:change={() => toggleGroupSelection(group.Id)}
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                        {/if}
                    {/each}
                </div>
            </div>
            <div class="modal-actions">
                <button class="ui button cancel-button" on:click={closeRemoveGroupModal}>{$translate('Cancel')}</button>
                <button 
                    class="ui negative button" 
                    on:click={removeGroups}
                    disabled={selectedGroupsToRemove.length === 0}
                >
                    Remove Selected Groups
                </button>
            </div>
        </div>
    </Modal>
  {/if}
  <style>
    /* Asegurar que el contenedor principal tenga suficiente espacio */
    :global(.article) {
        margin-left: 150px !important;
        padding-right: 30px !important;
        padding-left: 20px !important;
        overflow-x: auto !important;
        min-width: 0 !important;
        max-width: none !important;
    }

    /* Asegurar que el contenedor pusher tenga suficiente espacio */
    :global(.pusher) {
        margin-left: 0 !important;
        padding-right: 0 !important;
    }

    /* Asegurar que el body no tenga restricciones de ancho */
    :global(body) {
        overflow-x: auto !important;
        min-width: 0 !important;
    }

    /* Contenedor principal de la página */
    .page-content-container {
        min-width: 800px;
        overflow-x: auto;
    }

    /* Contenedor de la tabla con scroll horizontal */
    .table-container {
        overflow-x: auto;
        margin-bottom: 1rem;
    }

    /* Asegurar que la tabla tenga scroll horizontal si es necesario */
    .playerlist {
        min-width: 800px !important;
        width: 100% !important;
    }

    /* Estilos para el texto de paginación */
    .pagination-info {
        margin: 1rem 0;
        padding: 0.5rem 0;
        font-size: 0.9em;
        color: #666;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* Asegurar que el menú de paginación tenga suficiente espacio */
    .ui.pagination.menu {
        margin: 1rem 0;
        flex-wrap: wrap;
    }

    .numeric {
        font-family: monospace;
        text-align: right !important;
        width: 50px !important;
    }
    .groups-list-display {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    }
    .group-tag {
        background-color: #e8e8e8;
        border-radius: 4px;
        padding: 2px 8px;
        font-size: 0.9em;
        white-space: nowrap;
    }
    .text-muted {
        color: #999;
        font-style: italic;
    }
    .location-style-container {
        max-height: 400px;
        overflow-y: auto;
        margin: 10px 0;
    }
    .group-items-list {
        border: 1px solid #ddd;
        border-radius: 4px;
        background: white;
        margin: 10px 0;
    }

    .group-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 16px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }

    .group-item:hover {
        background-color: #f8f9fa;
    }

    .group-name {
        flex-grow: 1;
        margin-right: 10px;
    }

    .no-selection-item {
        padding: 12px 16px;
        cursor: pointer;
        border-bottom: 1px solid #eee;
        background-color: #f8f9fa;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .check-button {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #4CAF50;
    }

    .check-button i {
        color: white;
        font-size: 14px;
    }

    .modal-actions {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #eee;
    }

    .cancel-button {
        background-color: #fff !important;
        color: #333 !important;
        border: 1px solid #ddd !important;
    }

    .save-button {
        background-color: #4CAF50 !important;
        color: white !important;
    }

    .modal-content {
        padding: 20px;
    }

    /* Estilos específicos para el modal de grupos */
    .group-select-item {
        padding: 8px 16px;
        cursor: pointer;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .group-select-item:hover {
        background-color: #f8f9fa;
    }

    .group-select-item .check-button {
        opacity: 0;
        transition: opacity 0.2s;
    }

    .group-select-item.selected .check-button,
    .group-select-item:hover .check-button {
        opacity: 1;
    }

    .group-select-item.selected {
        background-color: #f8f9fa;
    }
    .status-button {
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;
        transition: opacity 0.2s;
        margin: 0 auto;
    }
    .status-button:hover {
        opacity: 0.9;
    }
    .status-button.enabled {
        background-color: #4CAF50;
    }
    .status-button:not(.enabled) {
        background-color: #F44336;
    }
    .status-button i {
        color: white;
        font-size: 16px;
    }
    .table-actions {
        display: flex;
        gap: 8px;
        margin-bottom: 16px;
    }
    .ui.basic.button {
        box-shadow: 0 0 0 1px rgba(34,36,38,.15) inset;
    }
    .ui.basic.button:hover {
        background-color: #f8f9fa !important;
    }
    .playerlist {
        font-size: 13px !important;
    }
    .playerlist th,
    .playerlist td {
        padding: 6px 8px !important;
        text-align: center !important;
        vertical-align: middle !important;
    }
    .playerlist td img {
        max-width: 40px;
        max-height: 40px;
        object-fit: contain;
    }
    .column-game-name {
        max-width: 200px !important;
        width: 200px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left !important;
    }
    .column-game-name span {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
    }
    .playerlist td.column-game-name {
        padding-right: 16px !important;
    }
    .column-game-code {
        min-width: 200px !important;
        max-width: 300px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: left !important;
    }
    .column-front-page {
        width: 80px !important;
        text-align: center !important;
    }
    .front-page-status {
        width: 32px;
        height: 32px;
        border: none;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        background-color: #F44336;
        transition: background-color 0.2s;
        cursor: pointer;
        padding: 0;
    }
    .front-page-status:hover {
        opacity: 0.9;
    }
    .front-page-status.active {
        background-color: #4CAF50;
    }
    .front-page-status i {
        color: white;
        font-size: 16px;
    }
    .column-image {
        width: 60px !important;
    }
    .column-enable {
        width: 60px !important;
        text-align: center !important;
    }
    .column-assign-groups {
        width: 80px !important;
    }
    .column-assign-groups .ui.button {
        padding: 4px 6px !important;
        font-size: 11px !important;
        min-height: 24px !important;
        line-height: 1 !important;
        width: auto !important;
        margin: 0 auto !important;
    }
    .column-remove-groups {
        width: 80px !important;
    }
    .column-remove-groups .ui.button {
        padding: 4px 6px !important;
        font-size: 11px !important;
        min-height: 24px !important;
        line-height: 1 !important;
        width: auto !important;
        margin: 0 auto !important;
    }
    .column-options {
        width: 50px !important;
    }
    .check-button:not(.enabled) {
        background-color: #f5f5f5;
        border: 1px solid #ddd;
    }
    .check-button:not(.enabled) i {
        color: #999;
    }
    .checkbox-container {
        position: relative;
        display: inline-block;
        cursor: pointer;
    }

    .checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    .checkmark {
        position: relative;
        display: inline-block;
        width: 24px;
        height: 24px;
        background-color: white;
        border: 1px solid #ddd;
        border-radius: 4px;
    }

    .checkbox-container input:checked ~ .checkmark {
        background-color: #4CAF50;
        border-color: #4CAF50;
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
        left: 8px;
        top: 4px;
        width: 6px;
        height: 12px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

    .checkbox-container input:checked ~ .checkmark:after {
        display: block;
    }

    .group-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 16px;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }

    .group-item:hover {
        background-color: #f8f9fa;
    }

    .group-name {
        flex-grow: 1;
        margin-right: 10px;
    }
  </style>
